module.exports = __webpack_public_path__ + "static/media/init_editor.3aaaef1a.svg";